import React from 'react';
import { useTheme } from '../contexts/ThemeContext';
import { cn } from '../ui/utils/cn';

/**
 * Dirham Symbol Component
 * Displays a stylized "D" with two horizontal lines (currency symbol style)
 * Works in both light and dark modes
 */
const DirhamSymbol = ({ 
  className = '', 
  size = 16,
  inline = false 
}) => {
  const { theme } = useTheme();
  const isDark = theme === 'dark';
  
  // Color adapts to theme: black on light, white on dark
  const strokeColor = isDark ? '#FFFFFF' : '#000000';
  
  const symbolStyle = {
    width: size,
    height: size * 1.2, // Slightly taller to accommodate the lines
    display: inline ? 'inline-block' : 'block',
    verticalAlign: inline ? 'middle' : 'baseline',
  };

  return (
    <svg
      className={cn('dirham-symbol', className)}
      style={symbolStyle}
      viewBox="0 0 40 48"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      aria-label="Dirham"
      role="img"
    >
      {/* Stylized "D" letterform */}
      {/* Vertical stem (thicker) */}
      <path
        d="M 8 8 L 8 40"
        stroke={strokeColor}
        strokeWidth="4"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      
      {/* Curved part of D - smoother arc */}
      <path
        d="M 8 8 Q 20 8 28 16 Q 32 20 32 24 Q 32 28 28 32 Q 20 40 8 40"
        stroke={strokeColor}
        strokeWidth="3.5"
        strokeLinecap="round"
        strokeLinejoin="round"
        fill="none"
      />
      
      {/* Top horizontal line - extends beyond left edge */}
      <line
        x1="2"
        y1="20"
        x2="32"
        y2="20"
        stroke={strokeColor}
        strokeWidth="2.5"
        strokeLinecap="round"
      />
      
      {/* Bottom horizontal line - extends beyond left edge */}
      <line
        x1="2"
        y1="28"
        x2="32"
        y2="28"
        stroke={strokeColor}
        strokeWidth="2.5"
        strokeLinecap="round"
      />
    </svg>
  );
};

export default DirhamSymbol;
